// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconEmail: React.FC<{}> = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12">
            <path
                fill="#CD4A23"
                d="M1.5,0 C0.6875,0 0,0.6875 0,1.5 C0,1.96875 0.21875,2.40625 0.59375,2.6875 L7.09375,7.5625 C7.625,7.96875 8.375,7.96875 8.90625,7.5625 L15.40625,2.6875 C15.78125,2.40625 16,1.96875 16,1.5 C16,0.6875 15.34375,0 14.5,0 L1.5,0 Z M0,4.125 L0,10 C0,11.09375 0.90625,12 2,12 L14,12 C15.09375,12 16,11.09375 16,10 L16,4.125 L9.8125,8.78125 C8.75,9.5625 7.28125,9.5625 6.1875,8.78125 L0,4.125 Z"
            />
        </svg>
    );
};

export default React.memo(IconEmail);
